/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
const dev = {
  apiGateway: {
    endpoints: [
      {
        name: "spoketree-community-capability",
        endpoint: "https://6w8y23jseh.execute-api.ap-southeast-2.amazonaws.com/dev",
        region: "ap-southeast-2"
      },
      {
        name: "spoketree-community-feature",
        endpoint: "https://b4mdos0p86.execute-api.ap-southeast-2.amazonaws.com/dev",
        region: "ap-southeast-2"
      },
      {
        name: "spoketree-database-auth",
        endpoint: "https://rqx7hokqlh.execute-api.ap-southeast-2.amazonaws.com/dev",
        region: "ap-southeast-2"
      },
      {
        name: "spoketree-database-unauth",
        endpoint: "https://63atikgiad.execute-api.ap-southeast-2.amazonaws.com/dev",
        region: "ap-southeast-2"
      },
      {
        name: "spoketree-exchange-message",
        endpoint: "https://2ijainr2vb.execute-api.ap-southeast-2.amazonaws.com/dev",
        region: "ap-southeast-2"
      },
      {
        name: "spoketree-exchange-message-transition",
        endpoint: "https://d0a9c1p3we.execute-api.ap-southeast-2.amazonaws.com/dev",
        region: "ap-southeast-2"
      },
      {
        name: "spoketree-exchange-report-execution",
        endpoint: "https://w4hrseday5.execute-api.ap-southeast-2.amazonaws.com/dev",
        region: "ap-southeast-2"
      },
      {
        name: "spoketree-exchange-iam-user",
        endpoint: "https://r5xb583hc5.execute-api.ap-southeast-2.amazonaws.com/dev",
        region: "ap-southeast-2"
      }
    ],
  },
  s3: {
    REGION: "ap-southeast-2",
    BUCKET: "dev-community-s3-storage8d9329be-uz0r1makqq1d"
  },
  cognito: {
    REGION: "ap-southeast-2",
    USER_POOL_ID: "ap-southeast-2_bamd5xw07",
    APP_CLIENT_ID: "4m2248ikui5t927e2bfm124a2f",
    IDENTITY_POOL_ID: "ap-southeast-2:0c28367a-7314-4406-9d79-a28e15e090fe"
  }
};

const staging = {
  apiGateway: {
    endpoints: [
      {
        name: "spoketree-community-capability",
        endpoint: "TODO",
        region: "ap-southeast-2"
      },
      {
        name: "spoketree-community-feature",
        endpoint: "https://hw06hm3e0h.execute-api.ap-southeast-2.amazonaws.com/staging",
        region: "ap-southeast-2"
      },
      {
        name: "spoketree-database-auth",
        endpoint: "https://eer4bd2jkc.execute-api.ap-southeast-2.amazonaws.com/staging",
        region: "ap-southeast-2"
      },
      {
        name: "spoketree-database-unauth",
        endpoint: "https://ezlpm29j4a.execute-api.ap-southeast-2.amazonaws.com/staging",
        region: "ap-southeast-2"
      },
      {
        name: "spoketree-exchange-message-transition",
        endpoint: "https://rdmc5hjkbl.execute-api.ap-southeast-2.amazonaws.com/staging",
        region: "ap-southeast-2"
      },
      {
        name: "spoketree-exchange-report-execution",
        endpoint: "https://ei70xd47ea.execute-api.ap-southeast-2.amazonaws.com/staging",
        region: "ap-southeast-2"
      }
    ],
  },
  // https://bitbucket.org/nellerconnect/spoketree-community-inf/issues/2/promote-v106-to-staging
  s3: {
    REGION: "ap-southeast-2",
    BUCKET: "staging-community-s3-storage8d9329be-hlnvdd2pkfy1"
  },
  cognito: {
    REGION: "ap-southeast-2",
    USER_POOL_ID: "ap-southeast-2_6fLwWnNbw",
    APP_CLIENT_ID: "7vdaed1tmtl1ui9glb8759lk7b",
    IDENTITY_POOL_ID: "ap-southeast-2:7eb051c1-753b-4dca-9b5a-7dfa443899d8"
  }
};

const prod = {
  apiGateway: {
    endpoints: [
      {
        name: "spoketree-community-capability",
        endpoint: "TODO",
        region: "ap-southeast-2"
      },
      {
        name: "spoketree-community-feature",
        endpoint: "https://7vjzvim2yh.execute-api.ap-southeast-2.amazonaws.com/prod",
        region: "ap-southeast-2"
      },
      {
        name: "spoketree-database-auth",
        endpoint: "https://kb84dqfhv0.execute-api.ap-southeast-2.amazonaws.com/prod",
        region: "ap-southeast-2"
      },
      {
        name: "spoketree-database-unauth",
        endpoint: "https://3uwrtsi349.execute-api.ap-southeast-2.amazonaws.com/prod",
        region: "ap-southeast-2"
      },
      {
        name: "spoketree-exchange-message-transition",
        endpoint: "https://xqemj5dto5.execute-api.ap-southeast-2.amazonaws.com/prod",
        region: "ap-southeast-2"
      },
      {
        name: "spoketree-exchange-report-execution",
        endpoint: "https://iy1mai7tu4.execute-api.ap-southeast-2.amazonaws.com/prod",
        region: "ap-southeast-2"
      }
    ],
  },
  // https://bitbucket.org/nellerconnect/spoketree-community-inf/issues/3/promote-v106-to-prod
  s3: {
    REGION: "ap-southeast-2",
    BUCKET: "prod-community-s3-storage8d9329be-15bfrogngao56"
  },
  // https://bitbucket.org/nellerconnect/spoketree-community-inf/issues/3/promote-v106-to-prod
  cognito: {
    REGION: "ap-southeast-2",
    USER_POOL_ID: "ap-southeast-2_fKIzamevC",
    APP_CLIENT_ID: "6qdqd5if05bm9phntk04lpa0a6",
    IDENTITY_POOL_ID: "ap-southeast-2:15096151-d651-4def-9b76-5d86b8d1ae71"
  }
};

const cloud = {
  aws: {
    amplify: {
      // Default to dev if not set
      ...(process.env.REACT_APP_STAGE === "prod" ? prod : (process.env.REACT_APP_STAGE === "staging" ? staging : dev)),
    }
  }
};

export default cloud;